<div class="zigbee-card" [class.inactive]="device.active === false">
  <div class="zb-main">
    <span class="zb-name">{{ device.name || device.ieee }}</span>
    <span class="zb-type">{{ typeName | translate }} · {{ 'zigbee.rule_count' | translate: { count: ruleCount } }}</span>
  </div>

  <div class="zb-readings">
    <span class="zb-value" *ngIf="isClimate && tempText">{{ tempText }}</span>
    <span class="zb-value" *ngIf="isClimate && humText">{{ humText }}</span>
    <span class="zb-state" *ngIf="!isClimate && stateText" [class.alarm]="alarm">{{ stateText | translate }}</span>

    <span class="zb-battery" *ngIf="battery !== null" [ngClass]="batteryClass" [title]="battery + '%'">
      <span class="battery-body"><span class="battery-level" [style.width.%]="battery"></span></span>
      <span class="battery-text">{{ battery }}%</span>
    </span>
  </div>

  <button class="settings-button" (click)="onEdit()">
    <img src="assets/icons/edit.svg" width="20" height="20" alt="Edit" />
  </button>
</div>
